import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import {
	ADMIN_SEARCH_DFS_PLAYERS,
	ADMIN_FILTER_DFS_PLAYERS,
	ADMIN_CLEAR_DFS_SEARCH,
	ADMIN_SAVE_DFS_PICK
} from '../../store/constants';

function PickForm(props) {
	const { sportsID, sportsName, slotOrder, existing, search, saving, user, dispatch, onDone } = props;

	const defaultLeagueFor = (id) => {
		if (id === 4) return 'IPL';
		return '';
	};
	const league = user?.sportsID === sportsID
		? (user?.league || defaultLeagueFor(sportsID))
		: defaultLeagueFor(sportsID);

	const existingPlayer = existing
		? {
			id: existing.playerID,
			name: existing.playerName,
			team: existing.team?.name || existing.team?.city || '',
			position: existing.position
		}
		: null;

	const [ query, setQuery ] = useState(existingPlayer?.name || '');
	const [ player, setPlayer ] = useState(existingPlayer);
	const [ propBet, setPropBet ] = useState(existing?.propBet || '');
	const [ open, setOpen ] = useState(false);

	const containerRef = useRef(null);

	useEffect(() => {
		dispatch({
			type: ADMIN_SEARCH_DFS_PLAYERS,
			payload: { sportsID, league, query: '' }
		});
		return () => dispatch({ type: ADMIN_CLEAR_DFS_SEARCH });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ sportsID, league ]);

	useEffect(() => {
		const onDocClick = (e) => {
			if (containerRef.current && !containerRef.current.contains(e.target)) {
				setOpen(false);
			}
		};
		document.addEventListener('mousedown', onDocClick);
		return () => document.removeEventListener('mousedown', onDocClick);
	}, []);

	const handleQueryChange = (e) => {
		const next = e.target.value;
		setQuery(next);
		setOpen(true);
		if (sportsID === 5) {
			// CFB: server-side search per keystroke (roster is too large to load all at once)
			if (next.trim().length >= 2) {
				dispatch({ type: ADMIN_SEARCH_DFS_PLAYERS, payload: { sportsID, league, query: next.trim() } });
			}
		} else {
			dispatch({ type: ADMIN_FILTER_DFS_PLAYERS, payload: { query: next.trim() } });
		}
	};

	const handleSelectPlayer = (p) => {
		setPlayer(p);
		setQuery(p.name || '');
		setOpen(false);
	};

	const handleSave = () => {
		if (!player?.id) return;
		dispatch({
			type: ADMIN_SAVE_DFS_PICK,
			payload: {
				sportsID,
				playerID: String(player.id),
				slotOrder: slotOrder || 1,
				propBet: propBet.trim() || null
			}
		});
		if (onDone) onDone();
	};

	const searchActiveForThisSport = search?.sportsID === sportsID;
	const results = searchActiveForThisSport ? (search.results || []) : [];
	const isSearching = searchActiveForThisSport && search?.isLoading;
	const showDropdown = open && (results.length > 0 || isSearching);

	return (
		<div className='admin-dfs__form' data-testid={`admin-dfs-form-${sportsName}`}>
			<h3>
				{existing ? 'Edit' : 'New'} pick — {sportsName?.toUpperCase()} Slot {slotOrder}
			</h3>

			<div
				ref={containerRef}
				className='admin-dfs__typeahead'
			>
				<label>
					Search player
					<input
						type='text'
						placeholder='Search player'
						value={query}
						onChange={handleQueryChange}
						onFocus={() => setOpen(true)}
						autoComplete='off'
					/>
				</label>

				{showDropdown && (
					<ul className='admin-dfs__search-results'>
						{isSearching && results.length === 0 && (
							<li className='admin-dfs__search-status'>Searching…</li>
						)}
						{!isSearching && results.length === 0 && (
							<li className='admin-dfs__search-status'>No players found</li>
						)}
						{results.map((p) => (
							<li
								key={p.id}
								className={player?.id === p.id ? 'is-selected' : ''}
								onMouseDown={(e) => { e.preventDefault(); handleSelectPlayer(p); }}
							>
								{p.name}
								{p.team && <> — {p.team}</>}
								{p.position && <> · {p.position}</>}
							</li>
						))}
					</ul>
				)}
			</div>

			{player && (
				<div className='admin-dfs__pick-line'>
					Selected: <strong>{player.name}</strong>{player.team ? ` (${player.team})` : ''}
				</div>
			)}

			<label>
				Prop Bet (optional)
				<input
					type='text'
					placeholder='e.g. Over 24.5 pts, 2+ touchdowns'
					value={propBet}
					onChange={(e) => setPropBet(e.target.value)}
					autoComplete='off'
				/>
			</label>

			<div className='admin-dfs__form-actions'>
				{onDone && (
					<Button variant='secondary' onClick={onDone} disabled={saving}>Cancel</Button>
				)}
				<Button
					variant='primary'
					onClick={handleSave}
					disabled={saving || !player?.id}
				>
					{saving ? 'Saving…' : 'Save'}
				</Button>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => ({
	user: state.user,
	search: state.adminDfsPicks?.search,
	saving: state.adminDfsPicks?.saving
});

export default connect(mapStateToProps)(PickForm);
